import { Camera, CheckCircle2, CloudOff, Database, WifiOff } from 'lucide-react';
import type { AppCapabilities } from '../hooks/useAppCapabilities';

export function CapabilityStrip({ capabilities, syncConfigured }: { capabilities: AppCapabilities; syncConfigured: boolean }) {
  const storageLabel = capabilities.storagePersisted ? 'Storage durable' : 'Storage ready';
  return (
    <div className="capability-strip" aria-label="App capabilities">
      <span><Database size={16} aria-hidden="true" />{storageLabel}</span>
      <span>{syncConfigured ? <CheckCircle2 size={16} aria-hidden="true" /> : <CloudOff size={16} aria-hidden="true" />}{syncConfigured ? 'Sync ready' : 'Sync off'}</span>
      <span>{capabilities.online ? <CheckCircle2 size={16} aria-hidden="true" /> : <WifiOff size={16} aria-hidden="true" />}{capabilities.online ? 'Offline ready' : 'Working offline'}</span>
      <span className="mobile-only"><Camera size={16} aria-hidden="true" />{capabilities.camera ? 'Camera ready' : 'Photo capture'}</span>
    </div>
  );
}
